import React from 'react';
import { Stepper, Step, StepLabel, StepIconProps } from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { styled } from '@mui/system';

const CustomStepIcon = styled('div')<StepIconProps>(({ theme, active, completed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 42,
    height: 42,
    borderRadius: '50%',
    backgroundColor: completed || active ? theme.palette.primary.main : theme.palette.grey[400],
    color: '#fff',
    fontSize: '18px',
    fontWeight: 700
}));

const CustomStepIconComponent: React.FC<StepIconProps> = (props) => {
    const { active, completed, icon } = props;
    return (
        <CustomStepIcon active={active} completed={completed} icon={undefined}>
            {completed ? <DoneRoundedIcon sx={{ fontSize: 20 }} /> : <span>{icon}</span>}
        </CustomStepIcon>
    );
};

interface StepperComponentProps {
    activeStep: number;
    steps: string[];
}

const StepperComponent: React.FC<StepperComponentProps> = ({ activeStep, steps }) => {
    return (
        <Stepper
            activeStep={activeStep - 1}
            sx={{
                my: 4,
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
            }}
        >
            {steps.map((label, idx) => (
                <Step key={idx}>
                    <StepLabel
                        StepIconComponent={CustomStepIconComponent}
                        sx={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 1,
                            '& .MuiStepLabel-iconContainer': {
                                paddingRight: 1
                            },
                            '& .MuiStepLabel-label': {
                                fontSize: '17px',
                                lineHeight: '18px',
                                letterSpacing: 0,
                                textTransform: 'uppercase',
                                whiteSpace: 'normal',
                                color: '#989898',
                                fontWeight: 700,
                                maxWidth: '350px'
                            },
                            '& .MuiStepLabel-label.Mui-active': {
                                color: '#000',
                                fontWeight: 700
                            }
                        }}
                    >
                        {label}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};

export default StepperComponent;
